import { Link, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/Button';
import WalletIcon from './developer/components/WalletIcon';

export default function WalletLoginPage() {
  const navigate = useNavigate();
  const handleConnectWallet = () => {
    // TODO(wallet-auth): adapt extension access and login to an approved backend contract.
    return;
    // Legacy connection entry point: await getWalletAccounts(wallet.name);
  };

  /* Historical login action, intentionally commented out.
     The legacy hook used a synthetic email and performWebAuthnLogin, then stored
     a bearer token. The current backend has no external-wallet login endpoint;
     adapt this action to its HttpOnly session contract before enabling it.
  const handleSignIn = async () => {
    if (!selectedAccount) return;
    if (!termsAccepted) {
      setError('Please accept the terms and conditions to continue.');
      return;
    }

    setError('');
    setStep('signing');

    try {
      const result = await walletLoginMutation.mutateAsync({
        address: selectedAccount.address,
        accountName: selectedAccount.name,
      });

      if (result.noProfile) {
        // The wallet address is authenticated but has no client/developer profile.
        // Redirect to the register role-selection page so the user can create one.
        // Pass the address as a query param — register pages may use it in future
        // to pre-fill the wallet flow.
        navigate(
          `/register?wallet=${encodeURIComponent(selectedAccount.address)}&reason=no_profile`,
        );
        return;
      }

      setStep('done');
      navigate('/dashboard');
    } catch (err) {
      const errorObj = err instanceof Error ? err : new Error('Unknown error');
      const kind = classifyWalletError(errorObj);
      setError(errorMessage(kind, errorObj.message));
      setStep('select-account');
    }
  };
  */

  return (
    <div className="onboardingContent">
      <div className="signupBtn">
        <span>Don't have an account yet?</span>
        <Button variant="secondary" onClick={() => navigate('/register')}>
          Sign up
        </Button>
      </div>
      <div className="title">
        <h1>Connect with Wallet</h1>
        <p>Choose a wallet extension to sign in</p>
      </div>
      <p
        id="wallet-unavailable"
        className="w-full text-sm text-[--text-dark-secondary]"
      >
        Wallet login is not available yet. Use your username and password or
        passkey for now.
      </p>
      <div className="walletCardGroup">
        {/* Display only: importing wallet-connect would also load the extension SDK. */}
        {(
          [
            ['talisman', 'Talisman'],
            ['polkadot-js', 'Polkadot.js'],
            ['subwallet-js', 'SubWallet'],
          ] as const
        ).map(([name, displayName]) => (
          <div key={name} className="walletCardItem !gap-4 max-sm:!flex-wrap">
            <div className="walletCardItem__info min-w-0">
              <div className="shrink-0">
                <WalletIcon name={name} size={40} />
              </div>
              <div className="infoText">
                <p className="infoText__title">{displayName}</p>
                <p className="infoText__subtitle">Unavailable</p>
              </div>
            </div>
            <Button
              type="button"
              variant="secondary"
              onClick={handleConnectWallet}
              disabled
              aria-label={`Connect ${displayName}`}
              aria-describedby="wallet-unavailable"
            >
              Connect
            </Button>
          </div>
        ))}
      </div>
      <div className="text-center">
        <Link
          to="/login"
          className="text-sm font-medium text-[--state-brand-active] hover:underline"
        >
          Login with username or passkey
        </Link>
      </div>
    </div>
  );
}
